var _style, _defs, _path, _rect, _path2, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _rect3, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteLogoSide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_612",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 507 81.4",
    style: {
      enableBackground: "new 0 0 507 81.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000161594672785962346170000005378273982139109773_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 507,
    height: 81.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040561096235645795010000014201717277438448574_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_611",
    style: {
      clipPath: "url(#SVGID_00000040561096235645795010000014201717277438448574_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_494",
    className: "st1",
    d: "M31.3,81.4V35.2H20.9c-1.4,0-2.7,0.4-3.7,1.3c-1,0.8-1.5,2-1.5,3.2v41.7H0V39.9 c0-5.1,2.2-9.9,6.1-13.1c4.1-3.6,9.3-5.6,14.8-5.5h57.4v60.1H62.6V35.2H46.9v46.3H31.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_406",
    x: 83.5,
    y: 21.3,
    className: "st1",
    width: 15.6,
    height: 60.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_495",
    className: "st1",
    d: "M104.3,21.3h52.2c5.4-0.1,10.7,1.9,14.8,5.5c3.9,3.2,6.1,8,6.1,13.1v41.5h-15.6V39.8 c0-1.2-0.5-2.3-1.5-3.1c-0.9-0.8-2-1.3-3.2-1.5h-37v46.2h-15.6V21.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_496",
    className: "st1",
    d: "M188.8,76c-3.9-3.2-6.2-8-6.2-13V39.8c0-5.1,2.2-9.9,6.2-13.1c4-3.6,9.3-5.5,14.7-5.4 l36.5-0.1c5.4-0.1,10.7,1.9,14.8,5.5c3.9,3.2,6.1,8,6.1,13.1V63c0,5-2.2,9.8-6.1,13c-4.1,3.6-9.3,5.5-14.8,5.4h-36.5 C198.1,81.5,192.9,79.6,188.8,76 M243.7,66.2c1-0.8,1.5-2,1.5-3.2V39.8c0-1.1-0.5-2.1-1.4-2.8c-0.8-0.8-1.8-1.3-2.9-1.6 c-0.2,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.5,0h-36.5c-0.4,0.1-0.7,0.2-1,0.3c-0.4,0.2-0.9,0.4-1.3,0.6c-0.8,0.4-1.5,0.9-2,1.6 c-0.6,0.6-0.9,1.4-0.9,2.2v22.9c0,1.2,0.5,2.4,1.5,3.1c0.9,0.8,2,1.4,3.2,1.6h37C241.4,67.6,242.7,67.1,243.7,66.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_497",
    className: "st1",
    d: "M266.1,21.3h52.2c5.4-0.1,10.7,1.9,14.8,5.5c3.9,3.2,6.1,8,6.1,13.1v41.5h-15.6V39.8 c0-1.2-0.5-2.3-1.5-3.1c-0.9-0.8-2-1.3-3.2-1.5h-37v46.2h-15.6V21.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_498",
    className: "st1",
    d: "M344.3,21.3h52.2c5.4-0.1,10.7,1.9,14.8,5.5c3.9,3.2,6.1,8,6.1,13.1v41.5h-15.6V39.8 c0-1.2-0.5-2.3-1.5-3.1c-0.9-0.8-2-1.3-3.2-1.5h-37v46.2h-15.6V21.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_499",
    className: "st1",
    d: "M489.3,21.3l-37.7,54.8c-1.4,1.9-4.8,3.7-6.6,4.4c-1.9,0.7-4,1-6.1,1c-4,0.1-8-1.4-11-4.1 c-2.9-2.4-4.6-5.9-4.6-9.7V21.3H439v40.8c0,0.6,0.2,1.2,0.7,1.5c0.4,0.3,1,0.5,1.5,0.5c0.1,0,0.2,0,0.2,0v0.4c0,0.1,0.1,0,0.3-0.1 l1.1-1l28.6-42.2H489.3z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_407",
    x: 491.3,
    y: 21.3,
    className: "st1",
    width: 15.6,
    height: 60.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_500",
    className: "st1",
    d: "M507,8.2c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8s3.6-8,8-8c0,0,0,0,0,0C503.4,0.1,507,3.7,507,8.2 C507,8.2,507,8.2,507,8.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_501",
    className: "st1",
    d: "M99.1,8c0,4.4-3.6,8-8,8s-8-3.6-8-8s3.6-8,8-8C95.5,0,99.1,3.6,99.1,8C99.1,8,99.1,8,99.1,8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_408",
    x: 355.3,
    y: 44.5,
    className: "st1",
    width: 51.1,
    height: 12.9
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_502",
    className: "st1",
    d: "M438.4,61.7c0,0,1.2,3.2,3.3,2.1c1.9-1,4.2-4.7,4.2-4.7l0.6,1.8l1.3,4c0,0-2.5,4.3-3.3,4.2 s-10.7-1.2-10.7-1.2l1-5.6L438.4,61.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogoSide);
export default __webpack_public_path__ + "static/media/white_logo_side.87e669a38ad2d5e87b5cef5a739d2454.svg";
export { ForwardRef as ReactComponent };